<template>
  <div class="container">
    <app-header title="添加其他号码" />
    <div class="login">
      <van-form>
        <van-field name="手机号码"
                   label="手机号码"
                   placeholder="输入有效手机号码"
                   :rules="[{ required: true, message: '输入有效手机号码' }]">
          <template #button>
            <van-button class="panel"
                        size="small"
                        type="default"
                        @click="show = true">获取验证码</van-button>
          </template>
        </van-field>
        <van-field center
                   clearable
                   label="验证码"
                   placeholder="输入六位验证码"
                   :rules="[{ required: true, message: '输入六位验证码' }]">
        </van-field>
        <div class="fixation">
          <div>保存此号码以后供授权使用</div>
          <van-switch active-color="#C9C9C9"
                      v-model="checked" />
        </div>
        <div class="achieve"
             @click="complete">完成</div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "addPhone",
  data () {
    return {
      checked: true,
    }
  },
  methods: {
    complete () {
      this.$router.push("/register")
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  .login {
    .panel {
      width: 88px;
      height: 30px;
      background: rgba(7, 193, 96, 1);
      border: 1px solid rgba(7, 193, 96, 1);
      opacity: 1;
      border-radius: 2px;
      color: #ffffff;
    }
    .fixation {
      display: flex;
      justify-content: space-between;
      padding: 15px;
      margin-bottom: 65px;
    }
    .achieve {
      width: 159px;
      height: 40px;
      background: rgba(237, 237, 237, 1);
      opacity: 1;
      border-radius: 4px;
      line-height: 40px;
      text-align: center;
      margin: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/addPhone.vue